import { get } from '@/core/api/api.service';
import { EventBannerInterface } from '@/shared/banner/event-banner.interface';

export const getBanner = (): Promise<EventBannerInterface> => {
  return get('/api/event-banner', { useGlobalLoading: true });
};
